import type { Authentication } from "@/lib/authentication"

export const buildProviderAuthenticationResult = (
  args: Partial<Authentication.ProviderAuthenticationResult>
): Authentication.ProviderAuthenticationResult => {
  return {
    authenticated: false,
    cancelled: false,
    emailAlreadyInUse: false,
    existingPatient: undefined,
    ...args,
  }
}
